<template>
  <div class="data-row">
    <div class="label-container">
      <DataLabel :label="label" />
    </div>
    <div class="value-container">
      <DataValue>
        <slot></slot>
      </DataValue>
    </div>
  </div>
</template>

<script setup lang="ts">
import DataLabel from '@/components/atom/data-section/DataLabel.vue'
import DataValue from '@/components/atom/data-section/DataValue.vue'

defineProps<{ label: string }>();
</script>

<style scoped lang="scss">
.data-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
}

.label-container {
  flex: 0 0 160px; // Fixed width for labels
  padding-right: 16px; // Consistent spacing between label and value
  @media (max-width: 768px) {
    flex: 0 0 120px;
  }
}

.value-container {
  flex: 1;
  min-width: 0; // This helps prevent flex items from overflowing
}
</style>
